import styled from "styled-components";

export default styled.div`
  & {
    width: 100%;
    height: 100%;
  }

  .section {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
  }

  .filter-section {
    display: flex;
    justify-content: space-between; /* Espaça os filtros uniformemente */
    margin-bottom: 20px;
    padding: 10px;
  }

  .filter-input {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .filter-input label {
    font-weight: bold;
    color: ${(props) => props.theme.colors.black || "#000"};
  }

  .filter-input input {
    padding: 5px;
    border: 1px solid ${(props) => props.theme.colors.gray || "#ccc"};
    border-radius: 4px;
    width: 200px;
    font-size: 14px;
  }

  .filter-input input:focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.primary || "#007bff"};
    box-shadow: 0 0 5px ${(props) => props.theme.colors.primary || "#007bff"};
  }

  .sort-button {
    background: transparent; /* Remove fundo */
    border: none; /* Remove borda */
    padding: 0; /* Remove padding */
    margin-left: 5px; /* Espaço entre texto e ícone */
    cursor: pointer; /* Indica clicabilidade */
    display: inline-flex; /* Alinha com o texto */
    align-items: center;
    color: ${(props) => props.theme.colors.gray || "#666"}; /* Cor do ícone */
  }

  .sort-button:hover {
    color: ${(props) =>
      props.theme.colors.primary || "#007bff"}; /* Cor ao passar o mouse */
  }
`;
